import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { H2 } from '@/frontend/design-system/_marketing/typography/Heading';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
type QuestionsAndAnswersSectionProps = {
  title: string;
  children: React.ReactNode;
};
export function QuestionsAndAnswersSection(t0) {
  const $ = _c(9);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <H2>{title}</H2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VerticalSpacer size="content" />;
    t3 = <Divider />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <div>{children}</div>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <main>{t1}{t2}{t3}{t4}</main>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}